/**
 * Extracts title (first markdown header after any leading config/JSON) and description (rest of content)
 * for use in Save Analysis. LLM response may start with JSON config, then the first # header is the title.
 */
export function parseAnalysisContent(fullText: string): { title: string; description: string } {
  const trimmed = fullText?.trim() ?? '';

  if (!trimmed) {
    return {
      title: 'Untitled analysis',
      description: '',
    };
  }

  const lines = trimmed.split(/\r?\n/);

  for (let i = 0; i < lines.length; i++) {
    const match = lines[i].match(/^#+\s+(.+)$/);

    if (match) {
      const title = match[1].trim();
      const descriptionLines = lines.slice(i + 1);
      const description = descriptionLines.join('\n').trim();

      return {
        title,
        description,
      };
    }
  }

  const firstNonEmpty = lines.find(l => l.trim());
  const firstIndex = firstNonEmpty ? lines.findIndex(l => l.trim() === firstNonEmpty) : 0;
  const title = firstNonEmpty?.trim() ?? 'Untitled analysis';
  const descriptionLines = lines.slice(firstIndex + 1);
  const description = descriptionLines.join('\n').trim();

  return {
    title,
    description,
  };
}
